import React from "react";
import { Link } from "react-router-dom";

function ServiceOne() {
  const products = [
    {
      id: 1,
      title: "Parlak Tel",
      image: "/assets/images/product/parlak-tel.png",
      path: "/urun/parlak-tel",
    },
    {
      id: 2,
      title: "Fosfat Kaplı Tel",
      image: "/assets/images/product/tavlanmis-tel.png",
      path: "/urun/tavli-tel",
    },
    {
      id: 3,
      title: "Çelik Tel",
      image: "/assets/images/product/celik-tel.png",
      path: "/urun/galvanizli-tel",
    },
    {
      id: 4,
      title: "Tavlanmış Tel",
      image: "/assets/images/product/tavlanmis-tel.png",
      path: "/urun/fosfatli-tel",
    },
    {
      id: 5,
      title: "Elektro Galvaniz Kaplı Tel",
      image: "/assets/images/product/elektro-galvaniz-kapli-tel.png",
      path: "/urun/bakir-kapli-tel",
    },
    {
      id: 6,
      title: "CNC Bükülmüş Tel",
      image: "/assets/images/product/cnc-bukulmus-tel.png",
      path: "/urun/duz-tel",
    },
    {
      id: 7,
      title: "Çubuk Kesilmiş Tel",
      image: "/assets/images/product/cubuk-kesilmis-tel.png",
      path: "/urun/ozel-uretim-teller",
    },
  ];

  return (
    <div>
      <style>
        {`
          .demirsan-products {
            padding: 80px 0;
            background: #ffffff;
          }

          .demirsan-products-title {
            margin-bottom: 45px;
            text-align: center;
          }

          .demirsan-products-title::before,
          .demirsan-products-title::after {
            content: none !important;
            display: none !important;
          }

          .demirsan-products-subtitle {
            margin: 0 0 10px;
            color: #df0a0a;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.2;
            text-transform: uppercase;
          }

          .demirsan-products-heading {
            margin: 0;
            color: #1c2539;
            font-size: 42px;
            font-weight: 700;
            line-height: 1.2;
          }

          .demirsan-product-card {
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
            background: #ffffff;
            border: 1px solid #eeeeee;
            border-radius: 8px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
            transition:
              transform 0.25s ease,
              box-shadow 0.25s ease,
              border-color 0.25s ease;
          }

          .demirsan-product-card:hover {
            transform: translateY(-6px);
            border-color: rgba(223, 10, 10, 0.25);
            box-shadow: 0 14px 35px rgba(0, 0, 0, 0.11);
          }

          .demirsan-product-image {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 270px;
            padding: 20px;
            overflow: hidden;
            background: #ffffff;
          }

          .demirsan-product-image img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            transition: transform 0.3s ease;
          }

          .demirsan-product-card:hover .demirsan-product-image img {
            transform: scale(1.04);
          }

          .demirsan-product-content {
            padding: 20px 15px 24px;
            text-align: center;
          }

          .demirsan-product-name {
            margin: 0;
            color: #111111;
            font-size: 21px;
            font-weight: 600;
            line-height: 1.3;
            transition: color 0.25s ease;
          }

          .demirsan-product-card:hover .demirsan-product-name {
            color: #df0a0a;
          }

          @media (max-width: 1199.98px) {
            .demirsan-product-image {
              height: 250px;
            }
          }

          @media (max-width: 767.98px) {
            .demirsan-products {
              padding: 55px 0;
            }

            .demirsan-products-title {
              margin-bottom: 30px;
            }

            .demirsan-products-heading {
              font-size: 34px;
            }

            .demirsan-product-image {
              height: 240px;
            }
          }

          @media (max-width: 575.98px) {
            .demirsan-products {
              padding: 40px 0;
            }

            .demirsan-products-heading {
              font-size: 28px;
            }

            .demirsan-product-image {
              height: 280px;
            }

            .demirsan-product-name {
              font-size: 20px;
            }
          }
            .demirsan-product-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
  cursor: default;
  user-select: none;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}
        `}
      </style>

      <section className="rts-service-area demirsan-products">
        <div className="container">
          {/* Başlık */}
          <div className="demirsan-products-title">
            <p className="demirsan-products-subtitle">Ürünlerimiz</p>

            <h2 className="demirsan-products-heading">
              Ürünler ve Müşterilerimizin Uygulamaları 
            </h2>
          </div>

          {/* Ürün kartları */}
          {/* Ürün kartları */}
          <div className="row g-4 justify-content-center">
            {products.map((product) => (
              <div
                className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12"
                key={product.id}
              >
                <div className="demirsan-product-card">
                  <div className="demirsan-product-image">
                    <img src={product.image} alt={product.title} />
                  </div>

                  <div className="demirsan-product-content">
                    <h3 className="demirsan-product-name">{product.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ServiceOne;
